function i(r = 0, e) {
  let s = 0;
  const a = typeof e == "object" ? {
    trimTrailingZeros: (e == null ? void 0 : e.trimTrailingZeros) ?? !0,
    showAsManyDecimalsAsNeeded: (e == null ? void 0 : e.showAsManyDecimalsAsNeeded) ?? !1,
    maxAsManyDecimalsAsNeeded: (e == null ? void 0 : e.maxAsManyDecimalsAsNeeded) ?? 8,
    onlyShowAsManyDecimalsAsNeededWhenZeroInt: (e == null ? void 0 : e.onlyShowAsManyDecimalsAsNeededWhenZeroInt) ?? !0
  } : {
    trimTrailingZeros: !0,
    showAsManyDecimalsAsNeeded: !1,
    maxAsManyDecimalsAsNeeded: 8,
    onlyShowAsManyDecimalsAsNeededWhenZeroInt: !0
  };
  if (r == null || Number.isNaN(Number(r)))
    s = 0;
  else if (a.trimTrailingZeros && Number.isInteger(Number(r)))
    s = r;
  else if (a.showAsManyDecimalsAsNeeded) {
    s = Number(r).toFixed(a.maxAsManyDecimalsAsNeeded);
    const [l, d] = s.split("."), m = d != null && d.length > 2 ? d.replace(/0+$/, "") : d;
    (a.onlyShowAsManyDecimalsAsNeededWhenZeroInt ? l === "0" : !0) && l != null && m != null && m.length > 2 ? s = `${l}.${m}` : s = Number(r).toFixed(2);
  } else {
    const l = `${r}`;
    l.includes(".") ? s = Number(r).toFixed(2) : s = r, a.trimTrailingZeros && l.endsWith(".00") && (s = Number.parseInt(l, 10).toString());
  }
  return `${s}`;
}
export {
  i as default
};
